import request from '@/utils/request';

let getUserList=(data)=>request.post('/api/user/list',data)
let addUser=(data)=>request.post('/api/user/add',data)
let editUser=(data)=>request.post('/api/user/edit',data)
let deleteUser=(data)=>request.get('/api/user/delete',data)

export default{
  getUserList,
  addUser,
  editUser,
  deleteUser
}